import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Layout } from '@components';
import Featured from '@components/sections/featured';

const StyledMain = styled.main`
  &.fillHeight {
    padding: calc(var(--nav-height) + 60px) 150px 0;

    @media (max-width: 1080px) {
      padding: calc(var(--nav-height) + 60px) 100px 0;
    }
    @media (max-width: 768px) {
      padding: calc(var(--nav-height) + 50px) 50px 0;
    }
    @media (max-width: 480px) {
      padding: calc(var(--nav-height) + 45px) 25px 0;
    }
  }

  header {
    max-width: 900px;
  }

  .intro {
    margin-top: 10px;
    max-width: 620px;
  }
`;

const BuiltPage = ({ location }) => (
  <Layout location={location}>
    <Helmet
      title="Built"
      meta={[
        {
          name: 'description',
          content: 'A curated portfolio of products and software projects across web and mobile.',
        },
      ]}
    />

    <StyledMain className="fillHeight">
      <header>
        <h1 className="big-heading">Some Things I’ve Built</h1>
        <p className="intro">
          A fuller list of projects—filtered by category and ordered by priority.
        </p>
      </header>

      <Featured limit={null} showHeading={false} showViewAllLink={false} />
    </StyledMain>
  </Layout>
);

BuiltPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default BuiltPage;
